/**
 * Created by tiedong on 2017/7/19.
 */
import * as types from '../constants/ActionTypes'
import {handleActions} from 'redux-actions'
const reducers = {}
const initialState = {
    reportPageOrForm:'reportPage',
    formOrVideoOrPhoto:'formReport',
    selectedCar:'',
    showPicModal:"closePicModal"
}


reducers[types.REPORT_PAGE_FORM] = {
    next(state, action) {
        return Object.assign({}, state, {reportPageOrForm: action.payload.isShow })
    }
}

reducers[types.FORM_VIDEO_PHOTO] = {
    next(state=initialState, action) {
        return Object.assign({}, state, {formOrVideoOrPhoto: action.payload.isShow })
    }
}

reducers[types.SELECTED_CAR] = {
    next(state=initialState, action) {
        return Object.assign({}, state, {selectedCar: action.payload.isShow })
    }
}

reducers[types.SHOWPICTUREMODAL] = {
    next(state=initialState, action) {
        return Object.assign({}, state, {showPicModal: action.payload.isShow })
    }
}


export default handleActions(reducers, initialState)